module.exports = __webpack_public_path__ + "assets/img/15.6320ed87.png";